import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, change, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteScheduling, renderAutoCompleteSingleSelect, renderCheckBox, renderDateField } from '../../../../components/reduxFields';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import Loader from '../../../../img/loader.gif';
import { getPatient, getMasterData } from '../../actions/index';
import history from '../../../../history';
import {getPatientListWithPermission} from '../../actions/index';
import {HasUrlAccess} from '../../actions/index';

const validate = (values) => {
  const errors = {};

  // if (!values.patientId) {
  //   errors.patientId = 'Please select client.';
  // }

  if (!values.masterNoteTypeId) {
    errors.masterNoteTypeId = 'Please select note type.';
  }
  return errors;
};

class Default_Sessionnotes_Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      patientId: 0,
      masterNoteTypeId: 1,
      iframeURL: '',
      isLoading: false,
      random: 0,
      FromDate: new Date().setDate(new Date().getDate() - 7),
      ToDate: new Date(),
      includeClinicalData: false,
      displayNonBillable: false,
      showUnrenderedAppointments: false,
      isDisplayNonBillableDisabled: false,
      noteTypeName: null,
      showRoleOfStaffInSignatureArea: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);    
    this.checkReportSearch = this.checkReportSearch.bind(this);
  }

  componentWillMount() {
    this.props.HasUrlAccess('/reports/session-notes-report');   
    let searchObj = {
      locationIds: '0',
      isActiveCheckRequired: 'YES',
      viewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission,
    };
    this.props.getPatientListWithPermission(searchObj);

    let masterData = {
      'masterdata': 'MASTERNOTETYPE,MASTERALLSTAFF',
    };
    this.props.getMasterData(masterData);
  }

  appointmentFilterByDate = (formData) => {
    this.resetIframe();

    let FromDateFormat;
    let ToDateFormat;
    // console.log('formData.legth---', Object.keys(formData).length);
    if (Object.keys(formData).length) {
      FromDateFormat = moment(this.state.FromDate).format('YYYY-MM-DD');
      ToDateFormat = moment(this.state.ToDate).format('YYYY-MM-DD');
    } else {
      let DateFormat = new Date().setDate(new Date().getDate() - 7);
      FromDateFormat = moment(DateFormat).format('YYYY-MM-DD');
      let dateFormat = new Date();
      ToDateFormat = moment(dateFormat).format('YYYY-MM-DD');
    }
    let REPORT_URL  = GetReportUrl(this.props.agencyName);
    let reportName = base64Encode('CL_DefaultSessionNotesWithDC_RPT');
    if(this.props.agencyName.toUpperCase() === 'EBSGA')
    {
      reportName = base64Encode('CL_EBSGA_SessionNotes_RPT');
    }
    else
    {
      if(this.state.masterNoteTypeId === 1)
        reportName = base64Encode('CL_DefaultSessionNotesWithDC_RPT');
      else if(this.state.masterNoteTypeId === 101)
        reportName = base64Encode('CL_SessionNotes_BT_Default_RPT');
      else if(this.state.masterNoteTypeId === 102)
        reportName = base64Encode('CL_SessionNotes_BCBA_Default_RPT');    
      else if(this.state.masterNoteTypeId > 102)
        reportName = base64Encode('CL_CustomSessionNotesWithDC_RPT');
      else 
          reportName = base64Encode('CL_DefaultSessionNotesWithDC_RPT');
    }
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "PatientId","Value": "` + this.state.patientId + `"},{"Name": "NoteTypeId","Value": "` + this.state.masterNoteTypeId + `"},{"Name": "IncludeClinicalData","Value": "` + this.state.includeClinicalData + `"},{"Name": "FromAppointmentDate","Value": "` + FromDateFormat + `"},{"Name": "ToAppointmentDate","Value": "` + ToDateFormat + `"},{"Name": "StaffIds","Value": "`+ (formData.staffIds && formData.staffIds.length > 0 ? formData.staffIds : 0) + `"},{"Name": "Offset","Value": "` + moment().utcOffset() + `"},{"Name": "ViewTeamClientsOnlyPermissionForReports","Value": "` + this.props.viewTeamClientsOnlyPermission + `"},{"Name": "LoginUserId","Value": "` + this.props.loginUserID + `"},{"Name": "ShowUnrenderedAppointments","Value": "` + this.state.showUnrenderedAppointments + `"},{"Name": "DisplayNonBillable","Value": "` + this.state.displayNonBillable + `"},{"Name": "ShowRoleOfStaffInSignatureArea","Value": "` + this.state.showRoleOfStaffInSignatureArea + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }


  handleChange = (input, selectedValue) => {
    this.setState({ [input.name]: selectedValue.value || 0 });
    input.onChange(selectedValue.value);

    if ((selectedValue.label || '').toLowerCase() === 'non-billable note') {
      this.setState({
        noteTypeName: (selectedValue.label || '').toLowerCase(),
        isDisplayNonBillableDisabled: true,
      },()=>{
            this.props.dispatch(change('Default_Sessionnotes_Report', 'displayNonBillable', true));
      });
    } else {
      this.setState({
        noteTypeName: (selectedValue.label || '').toLowerCase(),
        isDisplayNonBillableDisabled: false,
      },()=>{
            this.props.dispatch(change('Default_Sessionnotes_Report', 'displayNonBillable', false));
      });
    }
  }

  handleMultiChange = (input, selectedRecord) => {
    //if (input.name === 'staffIds') {
      input.onChange(selectedRecord);
    //}
    // else{
    //   input.onChange(selectedRecord.value);
    //   this.props.GetStaffByLocation(selectedRecord.value, 'YES')
    // }
  }


  onLoadReport = (e) => {
    this.setState({ isLoading: false });
  }

  resetIframe() {
    this.setState({ random: this.state.random + 1 });
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }

  checkReportSearch = (e, name) => {
    if (name === 'includeClinicalData') {
      if(e.target.checked) 
      {
        this.setState({includeClinicalData : true});        
      }
      else
      {
        this.setState({includeClinicalData : false});
      }
    }   
    if (name === 'displayNonBillable') {
      if(e.target.checked) 
      {
        this.setState({displayNonBillable : true});        
      }
      else
      {
        this.setState({displayNonBillable : false});
      }
    } 
    else if (name === 'showUnrenderedAppointments') {
      if(e.target.checked) 
      {
        this.setState({showUnrenderedAppointments : true});        
      }
      else
      {
        this.setState({showUnrenderedAppointments : false});
      }
    }
    else if (name === 'showRoleOfStaffInSignatureArea') {
      if(e.target.checked) 
      {
        this.setState({showRoleOfStaffInSignatureArea : true});        
      }
      else
      {
        this.setState({showRoleOfStaffInSignatureArea : false});
      }
    }
  }
  onBackClick = () => {
    history.push('/reports/audit-tools-reports');
  }
  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Audit Tools {' > '} Session Notes Report</h2>
        :
          <h2 className="page_title">Session Notes Report</h2>
        }        
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-6 mt-35">
                  <Field
                    name="patientId"
                    label="Select Client"
                    handleNewRequest={this.handleChange}
                    options={this.props.patientlist}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-6 require mt-35">
                  <Field
                    name="masterNoteTypeId"
                    label="Select Note Type"
                    handleNewRequest={this.handleChange}
                    options={this.props.masterNoteType}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 require mt-35">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-6 require mt-35">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    // minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 mt-40">
                    <Field name="staffIds"
                      label="Staff"
                      handleNewRequest={this.handleMultiChange}
                      options={this.props.allStaffs}
                      component={renderAutoCompleteScheduling}
                    />
                </div>  
                <div className="col-sm-3 mt-30">
                    <Field
                      className="mt20 mb0"
                      name="includeClinicalData"
                      label="Include Clinical Data"
                      onChange={(e) => this.checkReportSearch(e, 'includeClinicalData')}
                      component={renderCheckBox}
                    />
                </div>
                <div className="col-sm-3 mt-30">
                    <Field
                      className="mt20 mb0"
                      name="displayNonBillable"
                      label="Display Non-Billable"
                      disabled={this.state.isDisplayNonBillableDisabled}
                      onChange={(e) => this.checkReportSearch(e, 'displayNonBillable')}
                      component={renderCheckBox}
                    />
                </div>
              </div>
              <div className="row">    
                <div className="col-sm-6 mt-30">
                    <Field
                      className="mt20 mb0"
                      name="showUnrenderedAppointments"
                      label="Show Unrendered Appointments"
                      onChange={(e) => this.checkReportSearch(e, 'showUnrenderedAppointments')}
                      component={renderCheckBox}
                    />
                </div>        
                <div className="col-sm-3 mt-30">
                    <Field
                      className="mt20 mb0"
                      name="showRoleOfStaffInSignatureArea"
                      label="Show role of staff in signature area"
                      onChange={(e) => this.checkReportSearch(e, 'showRoleOfStaffInSignatureArea')}
                      component={renderCheckBox}
                    />
                </div>      
                <div className="col-sm-6 btn_lft reset-btn mt-30">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e) => this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

Default_Sessionnotes_Report = reduxForm({
  form: 'Default_Sessionnotes_Report',
  validate,
  enableReinitialize: true,
})(Default_Sessionnotes_Report);

function mapStateToProps(state) {
  let patients = [];
  if (state.report.patientList && state.report.patientList.data) {
    patients = state.report.patientList.data.patients;
  }
  // console.log('state.report.master_data............',state.report.master_data.allStaffs)

   
  // Start For Role Permission

 let userScreenPermission = [];
 if (state.login.userPermission) {
   let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
   userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
 }

 let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
 let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission && userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0] ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0].permission : false;


 // End For Role Permission

  return {
    orgID: state.login.loginUserInfo.organizationID,
    patientlist: patients,
    masterNoteType: state.report.master_data && state.report.master_data.masterNoteType,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    allStaffs : state.report.master_data ? state.report.master_data.allStaffs : [],
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
    loginUserID: (state.login.loginUserInfo && state.login.loginUserInfo.userID) || null,
  };
}
export default connect(mapStateToProps, { getPatientListWithPermission, HasUrlAccess, getMasterData })(Default_Sessionnotes_Report);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/AuditToolsReports/Default_Sessionnotes_Report.js